module.exports = __webpack_public_path__ + "img/AnnJefferson.c00894d3.png";